package com.jingfangpai.medicine.model

import com.jingfangpai.common.orm.mapping.Medicine
import kotlinx.serialization.Serializable

/**
 * 中药详情
 */
@Serializable
class MedicineDetail: Medicine() {
    var sameTypeOthers: List<Medicine> = emptyList()
}